/**
 * Replace old Complete Brands SVG logos (Firepush, Shopify accounts chrome
 * “Navigate to Online Store”, etc.) with the current Instant Brands logo.
 */
(function () {
  var cfg = document.getElementById("ib-brand-assets");
  if (!cfg) return;

  var logoUrl = "";
  try {
    logoUrl = JSON.parse(cfg.textContent || "{}").logo || "";
  } catch (e) {
    return;
  }
  if (!logoUrl) return;
  if (logoUrl.indexOf("//") === 0) logoUrl = window.location.protocol + logoUrl;

  function isOldLogo(img) {
    if (!img || img.tagName !== "IMG") return false;
    var src = img.getAttribute("src") || img.currentSrc || "";
    var cls = String(img.className || "");
    var alt = String(img.getAttribute("alt") || "").trim();
    if (/ib-complete-brands-logo/i.test(src)) return false;
    if (/LogoCompleteBrands/i.test(src)) return true;
    if (/_Logo_/.test(cls) && /instant brands/i.test(alt)) return true;
    if (/^instant brands$/i.test(alt)) {
      var parentText = (img.parentElement && img.parentElement.textContent) || "";
      if (/navigate to online store/i.test(parentText)) return true;
      if (/\bgP50U\b/.test(cls)) return true;
    }
    return false;
  }

  function upgrade(img) {
    if (!isOldLogo(img)) return;
    if ((img.getAttribute("src") || "") === logoUrl) return;
    img.setAttribute("src", logoUrl);
    img.removeAttribute("srcset");
    img.setAttribute("width", img.getAttribute("width") || "135");
    img.setAttribute("height", img.getAttribute("height") || "60");
    img.style.objectFit = "contain";
    img.style.maxWidth = "135px";
    img.style.height = "auto";
  }

  function scanNode(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.tagName === "IMG") upgrade(root);
    var list = root.querySelectorAll ? root.querySelectorAll("img") : [];
    for (var i = 0; i < list.length; i++) upgrade(list[i]);
    // Shopify accounts UI may render inside open shadow roots
    var all = root.querySelectorAll ? root.querySelectorAll("*") : [];
    for (var j = 0; j < all.length; j++) {
      if (all[j].shadowRoot) scanNode(all[j].shadowRoot);
    }
  }

  function scan() {
    scanNode(document);
  }

  scan();

  var obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === "attributes" && m.target && m.target.tagName === "IMG") {
        upgrade(m.target);
        continue;
      }
      var nodes = m.addedNodes || [];
      for (var n = 0; n < nodes.length; n++) {
        if (nodes[n].nodeType === 1) scanNode(nodes[n]);
      }
    }
  });

  obs.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["src", "srcset", "class", "alt"],
  });

  // Late-loading account widgets
  setTimeout(scan, 1500);
  setTimeout(scan, 4000);
})();
